import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classes.description, classes.textCenter}>
            USE YOUR FAMILY OFFICE TO STAY FOCUSED ON FUTURE LEGACY
          </h2>

          <h5>We help private individuals and family offices to take decisions and on defining a global strategy for their real estate portfolios.
          </h5>
          <h5>Every family office aims to centralise management to preserve, grow and transfer wealth: our role is to make the process as smooth and efficient as possible.</h5>
          <h3>The importance a family office</h3>
          <h5>
            Many families are turning to family offices as a way to meet their needs, to provide greater control over their wealth and to handle their affairs. Since every family has its own unique set of needs, there are as many types of family offices as there are families. Some provide basic administrative support while others oversee asset management or run the family’s daily affairs.
Once the family office is established, it is likely to serve multiple generations, across which there may be a range of different needs that require various wealth management strategies. A well-run family office successfully synthesizes these strategies to ensure that they support the wealth management goals of the family as a whole.
          </h5>
          <h5>Our team delivers a global, multi-jurisdictional service from our Spain base, serving ultra-high net worth families, entrepreneurs and landed private capital.
             We add an expert, independent perspective to established investment advice, thanks to our knowledge of investment across commercial, development, infrastructure,
             residential and rural property. Our range of professional services includes succession planning, valuation, expert witness, mediation,
             family constitutions and advice on setting up a new family office.
             We also act as a single hub and point of contact for single and multi-family offices alike, introducing and orchestrating wider advisory teams, specialists and intermediaries.
          </h5>
          <h3>Family business.</h3>
          <h5>
            Strategies of family businesss development
          </h5>
          <h5>Advisory services in planning the development of business in respect of product, organisational and investment aspects, taking into consideration the objectives of the family business.
</h5>
          <h5>As part of services provided, we consult and advise on the creation and implementation of strategic business activities. What is more, we cooperate with specialised consulting companies which have been advising for many years on the creation of a strategy, mission and vision individually for every company, which brings out the full potential and value of family business. At the same time, during the creation of development plans, we include a relevant issue of companys future and possible succession of business by proposing specific solutions in advance.
          </h5>

        </GridItem>
      </GridContainer>
    </div>
  );
}


export default withStyles(descriptionStyle)(SectionDescription);
